import { NotificationRule } from '@eppendorf/vnls-notifications-utils';
import { UserRole } from '@eppendorf/vnls-user-tenant-utils';

import { useCurrentUserId } from '$shared/custom-hooks/useCurrentUserId';
import { useTokenAttributes } from '$shared/custom-hooks/useTokenAttributes';

import { useGetUser } from '$features/users/users.api';

export function useCanPauseNotificationRule(notificationRule: NotificationRule): boolean {
  const { email: emailFromToken, tenantId } = useTokenAttributes(['email', 'tenantId']);
  const currentUserId = useCurrentUserId(emailFromToken, tenantId);
  const { data: user } = useGetUser(currentUserId || '');

  return (
    user?.roles?.includes(UserRole.LabAdmin) || notificationRule.createdBy === user?.email
  );
}
